export default {
    howToShop:'¿Como comprar?',
    howToShopLink:'como-comprar/eletronica',
    help:'Ajuda',
    helpLink:'ajuda',
    returnTicket: 'Retornar passagem',
    myPurchasesLink: 'usuario/miscompras',
    home: 'Home'
}